import AfnFashion from '../src/assets/travel/AfnFashion.jpg'
import AfnFashion1 from '../src/assets/travel/AfnFashion1.jpg'
import AmericanTourister from '../src/assets/travel/AmericanTourister.jpg'
import AmericanTourister1 from '../src/assets/travel/AmericanTourister1.jpg'
import KamiliantbyAmericanTourister from '../src/assets/travel/KamiliantbyAmericanTourister.jpeg'
import KamiliantbyAmericanTourister1 from '../src/assets/travel/KamiliantbyAmericanTourister1.jpeg'
import Magnum from '../src/assets/travel/Magnum.jpeg'
import Magnum1 from '../src/assets/travel/Magnum1.jpeg'
import SkybagsCardiff from '../src/assets/travel/SkybagsCardiff.jpg'
import SkybagsCardiff1 from '../src/assets/travel/SkybagsCardiff1.jpg'
import SkybagsRubikPolyester from '../src/assets/travel/SkybagsRubikPolyester.jpg'
import SkybagsRubikPolyester1 from '../src/assets/travel/SkybagsRubikPolyester1.jpg'
import TravelBackpack from '../src/assets/travel/TravelBackpack.jpg'
import TravelBackpack1 from '../src/assets/travel/TravelBackpack1.jpg'
import TravelBackpackHiking from '../src/assets/travel/TravelBackpackHiking.jpg'
import TravelBackpackHiking1 from '../src/assets/travel/TravelBackpackHiking1.jpg'
import AmericanTouristerIvy from '../src/assets/travel/AmericanTouristerIvy.jpg'
import AmericanTouristerIvy1 from '../src/assets/travel/AmericanTouristerIvy1.jpg'
import Duffel from '../src/assets/travel/Duffel.jpg'
import Duffel1 from '../src/assets/travel/Duffel1.jpg'
import LavieSport from '../src/assets/travel/LavieSport.jpg'
import LavieSport1 from '../src/assets/travel/LavieSport1.jpg'
import MiniAmericanTourister from '../src/assets/travel/MiniAmericanTourister.jpg'
import MiniAmericanTourister1 from '../src/assets/travel/MiniAmericanTourister1.jpg'
import SackBasics from '../src/assets/travel/SackBasics.jpg'
import SackBasics1 from '../src/assets/travel/SackBasics1.jpg'
import SackBasicsNylon from '../src/assets/travel/SackBasicsNylon.jpg'
import SackBasicsNylon1 from '../src/assets/travel/SackBasicsNylon1.jpg'
import SackBasicsRolling from '../src/assets/travel/SackBasicsRolling.jpg'
import SackBasicsRolling1 from '../src/assets/travel/SackBasicsRolling1.jpg'

const Tdata = [
    {
        img1: AfnFashion,
        img2: AfnFashion1,
        title:"Afn Fashion1",
        price:"720"
    },
    {
        img1: AmericanTourister,
        img2: AmericanTourister1,
        title:"American Tourister",
        price:"1020"
    },
    {
        img1: KamiliantbyAmericanTourister,
        img2: KamiliantbyAmericanTourister1,
        title:"Kamiliant",
        price:"620"
    },
    {
        img1: Magnum,
        img2: Magnum1,
        title:"Magnum",
        price:"820"
    },
    {
        img1: SkybagsCardiff,
        img2: SkybagsCardiff1,
        title:"Skybags Cardiff",
        price:"920"
    },
    {
        img1: SkybagsRubikPolyester,
        img2: SkybagsRubikPolyester1,
        title:"Skybags Rubik Polyester",
        price:"1120"
    },
    {
        img1: TravelBackpack,
        img2: TravelBackpack1,
        title:"Travel Backpack",
        price:"1520"
    },
    {
        img1: TravelBackpackHiking,
        img2: TravelBackpackHiking1,
        title:"Travel Backpack Hiking",
        price:"1450"
    },
    {
        img1: AmericanTouristerIvy,
        img2: AmericanTouristerIvy1,
        title:"American Tourister Ivy",
        price:"850"
    },
    {
        img1: Duffel,
        img2: Duffel1,
        title:"Duffel",
        price:"1550"
    },
    {
        img1: LavieSport,
        img2: LavieSport1,
        title:"Lavie Sport",
        price:"1340"
    },
    {
        img1: MiniAmericanTourister,
        img2: MiniAmericanTourister1,
        title:"Mini American Tourister",
        price:"1436"
    },
    {
        img1: SackBasics,
        img2: SackBasics1,
        title:"Sack Basics",
        price:"1680"
    },
    {
        img1: SackBasicsNylon,
        img2: SackBasicsNylon1,
        title:"Sack Basics Nylon",
        price:"1250"
    },
    {
        img1: SackBasicsRolling,
        img2: SackBasicsRolling1,
        title:"Sack Basics Rolling",
        price:"1456"
    },
];

export default Tdata;